import React from "react";

const TodoPage = () => {
  return <div>Hello, todo page</div>;
};

export default TodoPage;
